"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberArray = void 0;
exports.numberArray = (amount) => [...Array(amount).keys()];
//# sourceMappingURL=number-array.js.map